<template>
    <v-sheet color="transparent">
        <main-section>
            <lecture-categories />
            <lecture-list-title v-bind="{ title }" />
            <!-- filter / search -->
            <v-row>
                <template v-for="value in items">
                    <v-col cols="12" md="4" :key="value._id">
                        <lecture-list-card v-bind="{ value }" />
                    </v-col>
                </template>
            </v-row>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </main-section>
    </v-sheet>
</template>

<script>
import api from "@/api";

import MainSection from "@/components/client/main/main-section.vue";
import LectureCategories from "../lecture-categories.vue";
import LectureListCard from "./lecture-list-card.vue";
import LectureListTitle from "./lecture-list-title.vue";

export default {
    components: {
        MainSection,
        LectureCategories,
        LectureListCard,
        LectureListTitle,
    },
    props: {
        category: { type: Object, default: null },
        isStream: { type: Boolean, default: false },
        isMiceNow: { type: Boolean, default: false },
    },
    data: () => ({
        loading: false,
        lectures: [],

        limit: 12,
        summary: { totalCount: 0 },

        showsSearch: true,
    }),
    computed: {
        title() {
            if (this.category) return this.category?.name;
            if (this.isStream) return "실시간 교육";
            if (this.isMiceNow) return "MICE Now";
        },
        items() {
            return [...this.lectures];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            query = {
                ...query,
                category: this.category?.code,
                isStream: this.isStream,
                isMiceNow: this.isMiceNow,
            };

            if (!query._category) delete query._category;
            if (!query.isStream) delete query.isStream;
            if (!query.isMiceNow) delete query.isMiceNow;

            delete query.page;

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, lectures } = await api.v1.lectures.gets({
                    headers: { skip, limit },
                    params,
                });

                this.lectures = lectures;
                this.summary = summary;
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
};
</script>

<style></style>
